import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export function EmptyState({ icon, title, hint, action }: { icon?: ReactNode; title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center py-10 gap-3 text-center">
      <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-surface-muted text-ink-disabled ring-1 ring-inset ring-border-subtle">
        {icon ?? <Inbox className="w-5 h-5" />}
      </div>
      <div className="space-y-0.5">
        <p className="text-[13px] font-semibold text-ink-faint">{title}</p>
        {hint && <p className="text-[11px] text-ink-disabled">{hint}</p>}
      </div>
      {action}
    </div>
  );
}

export function Spinner() {
  return (
    <div className="flex items-center justify-center py-10">
      <div className="w-6 h-6 rounded-full border-2 border-primary-200 border-t-primary-800 animate-spin" />
    </div>
  );
}
